import { render, staticRenderFns } from "./Usuarios.vue?vue&type=template&id=58af484f&scoped=true&"
import script from "./Usuarios.vue?vue&type=script&lang=js&"
export * from "./Usuarios.vue?vue&type=script&lang=js&"
import style0 from "./Usuarios.vue?vue&type=style&index=0&id=58af484f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af484f",
  null
  
)

export default component.exports